<span class="text-zinc-200 group-first:hidden" aria-hidden="true">
  <vx-icon name="caret-right" size="xs" />
</span>
<a
  [routerLink]="link()"
  [attr.aria-current]="link() === null ? 'page' : null"
  [class]="classes()">
  <ng-content></ng-content>
</a>
